import { getRequest } from "../../shared/api/axiosHandler";

export const getProductsByAccountId = async (id, page = 0, size = 20, sort = "", search = "") => {
  try {
    let queryParams = `?page=${page}&size=${size}`;
    if (sort) queryParams += `&sort=${sort}`;
    if (search) queryParams += `&search=${encodeURIComponent(search)}`;
    return await getRequest(`/public/products/account/${id}${queryParams}`);
  } catch (error) {
    throw error;
  }
};
